import { Box, Typography } from "@mui/material";
import { Flex, HStack } from "@zfp-akademie-a-s/zfp-design";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { ReactNode } from "react";

type Props = {
  title: string;
  icon: ReactNode;
};

export const Subheading = ({ title, icon }: Props) => {
  return (
    <HStack spacing={Spacing.M} alignItems={"center"}>
      <Flex pt={Spacing.S} sx={{ color: "primary.main" }}>
        {icon}
      </Flex>
      <Typography variant="subtitle2">{title}</Typography>
    </HStack>
  );
};
